import './ImageRadioPicker.css';
import * as React from "react";

export default class ImageRadioPicker extends React.Component {
    handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            this.props.onSelect(this.props.value)
        }
    }

    isCurrent = () => {
        if (this.props.child){
            return this.props.current && this.props.current[this.props.child] === this.props.value[this.props.child]
        } else {
            return this.props.current === this.props.value;
        }
    }

    getAlt = () => {
        if (this.props.child){
            return this.props.value[this.props.child];
        } else {
            return this.props.value;
        }
    }

    render() {
        return (
            <label tabIndex="0"
                   className="radio-select"
                   onClick={() => {
                       this.props.onSelect(this.props.value)
                   }}
                   title={this.getAlt()}
                   onKeyPress={this.handleKeyPress}>
                <img className={this.isCurrent() ? "checked noselect" : "noselect"}
                     src={this.props.image}
                     alt={this.getAlt()}
                />
            </label>
        );
    }
}
